var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2132 13.5315C27.536 13.5315 26.6389 13.5165 25.522 13.5165C22.7981 13.5165 20.5583 11.262 20.5583 8.5125V3.6885C20.5583 3.309 20.2553 3 19.8796 3H11.9454C8.24275 3 5.25 6.039 5.25 9.7635V25.926C5.25 29.8335 8.38533 33 12.2544 33H24.0694C27.7587 33 30.75 29.9805 30.75 26.253V14.2065C30.75 13.8255 30.4485 13.518 30.0712 13.5195C29.4371 13.524 28.6766 13.5315 28.2132 13.5315Z",
    fill: "url(#paint0_linear_1709_14320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.126 3.85093C23.6775 3.38443 22.8945 3.70543 22.8945 4.35193V8.30743C22.8945 9.96643 24.261 11.3314 25.92 11.3314C26.9655 11.3434 28.4175 11.3464 29.6505 11.3434C30.282 11.3419 30.603 10.5874 30.165 10.1314C28.5825 8.48593 25.749 5.53693 24.126 3.85093Z",
    fill: "url(#paint1_linear_1709_14320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.627 22.3392C22.2435 22.3392 22.7445 22.8402 22.7445 23.4567C22.7445 24.0732 22.2435 24.5727 21.627 24.5727H13.461C12.8445 24.5727 12.345 24.0732 12.345 23.4567C12.345 22.8402 12.8445 22.3392 13.461 22.3392H21.627ZM18.5383 14.8479C19.1548 14.8479 19.6558 15.3489 19.6558 15.9654C19.6558 16.5819 19.1548 17.0814 18.5383 17.0814H13.4608C12.8443 17.0814 12.3448 16.5819 12.3448 15.9654C12.3448 15.3489 12.8443 14.8479 13.4608 14.8479H18.5383Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1709_14320",
    x1: 18,
    y1: 3,
    x2: 18,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1709_14320",
    x1: 26.6307,
    y1: 3.62976,
    x2: 26.6307,
    y2: 11.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC31A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.0c62a308eb181cd16a026a9423ada2ad.svg";
export { ForwardRef as ReactComponent };